/**
 * lower-fv 内の .main-heading がビューポート上端から何 px 下にあるかを表示するデバッグ用オーバーレイ。
 * 任意のページ URL に ?debug_heading を付けて有効化。
 * オーバーレイをクリックするか Esc で除去（リロードするまで再表示しない）。
 */
const PARAM = 'debug_heading';

export function initLowerFvHeadingDebug(): void {
  if (!new URLSearchParams(location.search).has(PARAM)) {
    return;
  }

  const heading = document.querySelector<HTMLElement>('.lower-fv .main-heading');
  if (!heading) {
    return;
  }

  const panel = document.createElement('div');
  panel.id = 'lower-fv-heading-debug';
  panel.setAttribute('role', 'status');
  panel.setAttribute('aria-live', 'polite');
  Object.assign(panel.style, {
    position: 'fixed',
    top: '8px',
    left: '8px',
    zIndex: '2147483647',
    padding: '10px 14px',
    fontFamily: 'ui-monospace, monospace',
    fontSize: '13px',
    lineHeight: '1.4',
    background: 'rgba(0,0,0,0.88)',
    color: '#7fff7f',
    borderRadius: '6px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.35)',
    cursor: 'pointer',
    userSelect: 'none',
    maxWidth: 'min(96vw, 420px)',
  });
  panel.title = 'クリックまたは Esc キーで非表示';

  let raf = 0;
  const update = (): void => {
    const topPx = Math.round(heading.getBoundingClientRect().top);
    panel.textContent = `lower-fv .main-heading — ビューポート上端から ${topPx}px`;
  };

  const scheduleUpdate = (): void => {
    if (raf !== 0) {
      return;
    }
    raf = requestAnimationFrame(() => {
      raf = 0;
      update();
    });
  };

  update();
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('scroll', scheduleUpdate, { passive: true, capture: true });

  const teardown = (): void => {
    panel.remove();
    window.removeEventListener('resize', scheduleUpdate);
    window.removeEventListener('scroll', scheduleUpdate, { capture: true });
    document.removeEventListener('keydown', onKeyDown);
  };

  const onKeyDown = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') {
      teardown();
    }
  };

  panel.addEventListener('click', teardown);
  document.addEventListener('keydown', onKeyDown);

  document.body.appendChild(panel);
}
